import React, {useState} from "react";
import { setSimulateurObject } from "../../../actions/simulateur.action";
import { styles } from "../../../stylesheets/simulateurs.css";
import SelectDepartement from "../../../components/selects/select.departement.js";
import ConventionHonoraires from "../../../components/questions/ConventionHonoraires.js";
import TextSimulateurTitle from "../../../components/texts/text.simulateurTitle";
import TextfieldRemarques from "../../../components/textfields/textfiel.remarques";
import { useDispatch } from "react-redux";

// Convention d'honoraires
// simulateur id 116

function Simulateur_116(props) {
  const dispatch = useDispatch();
  let currUser = JSON.parse(localStorage.getItem("user"));
    let currUserDep = 0
    if (currUser.societe_zip.startsWith("97")) {
        let trimedZip;
        trimedZip = currUser.societe_zip.slice(0, 3);
        currUserDep = parseInt(trimedZip)
    } else {
        let trimedZip;
        trimedZip = currUser.societe_zip.slice(0, 2);
        currUserDep = parseInt(trimedZip)
    }

  const [departement, setDepartement] = useState(0)

  const handleChange = async (setter, value) => {
    if (setter === setDepartement) {
        setDepartement(parseInt(value))
    } else setter(value);
    setInRedux(setter, value)
  };

  const handleChangeRemarque = (value) => {
    localStorage.setItem("remarque", value);
  };

  const genericHandleChange = (setter, value) => {
    setter(value);
  };
  function setInRedux(setter, value) {
    let object = {
      "simulateurid": props.simulateur.id,
      "departementid": departement,
    };

    if (setter === setDepartement) {
      object.departementid = parseInt(value)
    }
    
    dispatch(setSimulateurObject(object));
        
  }
  
  return (
    <div style={styles.container}>
      <div className="cardSimulateur">
        <TextSimulateurTitle title={props.simulateur.name} currentSimuId={props.simulateur.id} />
        <TextfieldRemarques handleChange={handleChangeRemarque} />
        
        <div style={styles.cardSubTitle}>
          Rappel des articles suivants :
          <ul>
            <li>Article L.444-1 du Code de commerce</li>
            <li>Annexe 4-9 du Code de commerce (décret n°2016-230 du 26 février 2016)</li>
            <li>Article R.444-16 du Code de commerce</li>
          </ul>
        </div>

        {props.departements && props.departements.length > 0 ?
            <div className="cardRow">
                <div style={styles.cardElemVerticalyCenter}>
                    Département :
                </div>

                <SelectDepartement items={props.departements} nameField={"name"} defaultValue={currUserDep} optionValue={"id"}
                    handleChange={handleChange} setter={setDepartement} />
            </div>
            :
            <></>
        }
        <ConventionHonoraires
            simulateur_116={true}
            conventionHonoraires={1}
            handleChange={genericHandleChange}

            nombreConventionHonoraires={props.nombreConventionHonoraires}
            setNombreConventionHonoraires={props.setNombreConventionHonoraires}
            
            objectConventionHonoraires={props.objectConventionHonoraires}
            setObjectConventionHonoraires={props.setObjectConventionHonoraires}

            montantConventionHonoraires={props.montantConventionHonoraires}
            setMontantConventionHonoraires={props.setMontantConventionHonoraires}
            nomSignataireConventionHonoraires={props.nomSignataireConventionHonoraires}
            setNomSignataireConventionHonoraires={props.setNomSignataireConventionHonoraires}
            adresseSignataireConventionHonoraires={props.adresseSignataireConventionHonoraires}
            setAdresseSignataireConventionHonoraires={props.setAdresseSignataireConventionHonoraires}
        />
      </div>
    </div>
  );
}

export default Simulateur_116;